var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":"Búsqueda grupal"}},[_c('RevisionCodigosVue',{staticClass:"mt-2"})],1),_c('vs-tab',{attrs:{"label":"Búsqueda individual"}},[_c('seccionBuscarVue',{staticClass:"mt-2"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }